module.exports = __webpack_public_path__ + "staticcomp/img/share.7b5a43f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/2/share.jpg
// module id = Ljxp
// module chunks = 39